<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Row>
            <Col span=1>
                <div style="padding-top: 16px;">
                    <Button type="text" icon="ios-search" shape="circle"
                        size="large" onclick="this.blur()" @click="onClick" />
                    <Button type="text" icon="ios-switch" shape="circle"
                        size="large" onclick="this.blur()" @click="switchChange" />
                </div>
            </Col>
            <Col span=23>
                <div id="salesChart" :style="echartStyle"></div>
            </Col>
        </Row>
        <Drawer title="检索条件" class="scrollbar" v-model="showSearchDrawer" width="360" :styles="styles" :inner="true" :transfer="false">
            <Form ref="formSearch" :model="formSearch" :rules="ruleSearch">
                <FormItem label="时间" label-position="top">
                    <DatePicker :transfer="true" v-model="formSearch.echartDate" type="date" split-panels
                        placeholder="不筛选时间..." :options="datePickerOptions" style="width:326px;" :clearable="false"></DatePicker>
                </FormItem>
                <FormItem label="时间类型" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateType"  @on-change="changeDateType">
                        <Option value="YEAR">年</Option>
                        <Option value="QUARTER">季度</Option>
                        <Option value="MONTH">月</Option>
                        <Option value="DAY">日</Option>
                    </Select>
                </FormItem>
                <FormItem label="间隔周期" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateCircle">
                        <Option v-for="item in [1,2,3,4,5,10]" :value="item" :key="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="时间跨域" label-position="top">
                    <Select :transfer="true" v-model="formSearch.echartDateLength">
                        <Option v-for="item in [1,2,3,4,5,6,7,8,9,10]" :value="item" :key="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="echartArea" label="区域(单选显示范围为营业厅下员工)" label-position="top">
                    <Select :transfer="true" multiple v-model="formSearch.echartArea">
                        <Option v-for="item in governingList" :value="item.governingBodyId" :key="item">{{item.governingBodyName}}</Option>
                    </Select>
                </FormItem>
                <div style="width: 100%; position: absolute; bottom: 0; left: 0; border-top: 1px solid #e8e8e8;
                            padding: 10px 16px; text-align: right; background: #fff;">
                    <Button type="primary" long @click="onCommit">设置</Button>
                </div>
            </Form>
        </Drawer>
    </div>
</template>

<script>
    export default {
        name: "eCharts_sales",
        computed: {
            echartStyle() {
                var style = {};
                style.width = this.width * 0.76 + 'px';
                style.height = this.height * 0.8 + 'px';
                return style;
            }
        },
        mounted(){
            $("div.ivu-drawer-body").addClass("scrollbar");
            var that = this;
            that.isSpinShow = true;
            $.ajax({
                url: "/api/info/governingBodyList",
                contentType: "application/json",
                type: "post",
                data:JSON.stringify({}),
                dataType: "json",
                success: function(data) {
                    if(data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }
                    that.governingList = data.body;
                    that.governingList.map(item=>{
                        that.formSearch.echartArea.push(item.governingBodyId);
                    })
                    that.getData();
                },
                error: function(textStatus) {
                    that.$Notice.error({
                        title: "异常",
                        desc: "接口请求异常"
                    });
                }
            });
        },
        data(){
            const validateArea = (rule, value, callback) => {
                if (value.length <= 0) {
                    callback(new Error('至少选择一个区域...'));
                } else {
                    callback();
                }
            };
            return{
                isSpinShow: false,
                showSearchDrawer: false,
                height: document.body.clientHeight,
                width: document.body.clientWidth,
                receiveData: [],
                switchModel: true,
                governingList: [],
                dateType: "MM-dd",
                formSearch: {
                    echartDate: global.dateFtt("yyyy-MM-dd hh:mm:ss",
                        new Date(new Date().getTime() - 3600 * 1000 * 24 * 5)),
                    echartDateType: "DAY",
                    echartDateCircle: 1,
                    echartDateLength: 5,
                    echartArea: []
                },
                ruleSearch: {
                    echartArea: [{
                        required: true,
                        validator: validateArea,
                        trigger: 'change'
                    }]
                },
                styles: {
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },
                datePickerOptions: {
                    shortcuts: [{
                        text: '一周前',
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            return date;
                        }
                    }, {
                        text: '昨天',
                        value() {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            return date;
                        }
                    }, {
                        text: '现在',
                        value() {
                            const date = new Date();
                            return date;
                        }
                    }]
                },
                option: {
                    baseOption: {
                        title: {
                            subtext: '营业额统计'
                        },
                        tooltip: {
                        },
                        legend: {
                            x: 'right',
                            data: []
                        },
                        calculable: true,
                        grid: [
                            {
                                left: '5%',
                                right: '2%',
                                top: '20%',
                                bottom: '55%',
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'shadow',
                                        label: {
                                            show: true,
                                            formatter: function(params) {
                                                return params.value.replace('\n', '');
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                left: '5%',
                                right: '2%',
                                top: '65%',
                                bottom: '5%',
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'shadow',
                                        label: {
                                            show: true,
                                            formatter: function(params) {
                                                return params.value.replace('\n', '');
                                            }
                                        }
                                    }
                                }
                            }
                        ],
                        xAxis: [
                            {
                                'type': 'category',
                                'axisLabel': {
                                    'interval': 0,
                                    'inside': false
                                },
                                triggerEvent : true,
                                data: [],
                                splitLine: {
                                    show: false
                                },
                                gridIndex: 0
                            },
                            {
                                'type': 'category',
                                'axisLabel': {
                                    'interval': 0,
                                    'inside': false
                                },
                                triggerEvent : true,
                                data: [],
                                splitLine: {
                                    show: false
                                },
                                gridIndex: 1
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                name: 'm³',
                                gridIndex: 0
                            },
                            {
                                type: 'value',
                                name: '元',
                                gridIndex: 1
                            }
                        ],
                        title : [
                            {
                                text: '按气充值统计',
                                top: '5%'
                            },
                            {
                                text: '按金额充值统计',
                                top: '50%'
                            }
                        ],
                        series: [ {
                            name: '姓名',
                            type: 'pie',
                            radius : '55%',
                            center: ['40%', '50%'],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }]
                    },
                    options: []
                }
            }
        },
        methods:{
            changeDateType(){
                switch (this.formSearch.echartDateType){
                    case "YEAR":
                        this.dateType = "yy-MM";
                        break;
                    case "QUARTER":
                        this.dateType = "yy-MM";
                        break;
                    case "MONTH":
                        this.dateType = "MM-dd";
                        break;
                    case "DAY":
                        this.dateType = "MM-dd";
                        break;
                    default:
                        this.dateType = "MM-dd";
                        break;
                }
            },
            switchChange(){
                this.switchModel = !this.switchModel;
                this.load(); 
            },
            onClick(){
                this.showSearchDrawer = true;
            },
            onCommit(){
                var that = this;
                that.$refs['formSearch'].validate((valid) => {
                    if (valid) {
                        that.showSearchDrawer = false;
                        that.getData();
                    }
                });
            },
            load(){
                if (this.switchModel){
                    this.showData();
                } else {
                    this.switchData();
                }
                let salesChart = this.$echarts.init(document.getElementById("salesChart"));
                salesChart.setOption(this.option, true);
            },
            getData(param){
                var that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/recharge/countSales",
                    contentType: "application/json",
                    type: "post",
                    data:JSON.stringify(
                        that.formSearch
                    ),
                    dataType: "json",
                    success: function(data) {
                        if(data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.receiveData = data.body;
                        that.load();
                        that.isSpinShow = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            switchData(){
                var that = this;
                that.option.baseOption.xAxis[0].data = [];
                that.option.baseOption.xAxis[1].data = [];
                that.option.baseOption.series = [];
                that.option.baseOption.legend.data = [];
                that.receiveData.map((item,index)=>{
                    var tempData = {};
                    var tempData1 = {xAxisIndex: 1, yAxisIndex: 1};
                    tempData['name'] = global.dateFtt(
                        that.dateType, new Date(that.formSearch.echartDate)
                        .dateAdd(that.formSearch.echartDateType, index * that.formSearch.echartDateCircle));
                    tempData['type'] = 'bar';
                    tempData['data'] = [];
                    tempData1['name'] = global.dateFtt(
                        that.dateType, new Date(that.formSearch.echartDate)
                        .dateAdd(that.formSearch.echartDateType, index * that.formSearch.echartDateCircle));
                    tempData1['type'] = 'bar';
                    tempData1['data'] = [];
                    that.option.baseOption.legend.data.push(tempData['name']);
                    item.map(param=>{
                        tempData['data'].push(param.flowSum);
                        tempData1['data'].push(param.priceSum);
                        if (index == 0) {
                            that.option.baseOption.xAxis[0].data.push(param.governingBodyName);
                            that.option.baseOption.xAxis[1].data.push(param.governingBodyName);
                        }
                    });
                    that.option.baseOption.series.push(tempData);
                    that.option.baseOption.series.push(tempData1);
                });
            },
            showData(){
                var that = this;
                that.option.baseOption.xAxis[0].data = [];
                that.option.baseOption.xAxis[1].data = [];
                that.option.baseOption.series = [];
                that.option.baseOption.legend.data = [];
                var changeData = that.receiveData[0];
                changeData.map((item,index)=>{
                    var tempData = {};
                    var tempData1 = {xAxisIndex: 1, yAxisIndex: 1};
                    tempData['name'] = item.governingBodyName;
                    tempData['type'] = 'bar';
                    tempData['data'] = [];
                    tempData1['name'] = item.governingBodyName;
                    tempData1['type'] = 'bar';
                    tempData1['data'] = [];
                    that.option.baseOption.legend.data.push(tempData['name']);
                    that.receiveData.map((param,childIndex)=>{
                        tempData['data'].push(param[index].flowSum);
                        tempData1['data'].push(param[index].priceSum);
                        if (index == 0) {
                            that.option.baseOption.xAxis[0].data.push(
                                global.dateFtt(that.dateType, new Date(that.formSearch.echartDate)
                                .dateAdd(that.formSearch.echartDateType, childIndex * that.formSearch.echartDateCircle)));
                            that.option.baseOption.xAxis[1].data.push(
                                global.dateFtt(that.dateType, new Date(that.formSearch.echartDate)
                                .dateAdd(that.formSearch.echartDateType, childIndex * that.formSearch.echartDateCircle)));
                        }
                    });
                    that.option.baseOption.series.push(tempData);
                    that.option.baseOption.series.push(tempData1);
                });
            }
        }
    }
    Date.prototype.dateAdd = function(interval, number) {
        var d = this;
        var k = {
            'YEAR': 'FullYear',
            'QUARTER': 'Month',
            'MONTH': 'Month',
            'WEEK': 'Date',
            'DAY': 'Date',
            'HOUR': 'Hours',
            'MINUTE': 'Minutes',
            'SECOND': 'Seconds',
            'ms': 'MilliSeconds'
        };
        var n = {
            'QUARTER': 3,
            'WEEK': 7
        };
        eval('d.set' + k[interval] + '(d.get' + k[interval] + '()+' + ((n[interval] || 1) * number) + ')');
        return d;
    }
</script>

<style>
    /*自定义滚动条*/ 
    .scrollbar { 
      overflow-y: auto; 
    } 
    .scrollbar::-webkit-scrollbar { 
      width: 0px; 
    } 
</style>
